export const catalog = [
  {
    code: "600088V",
    name: "Seat Covers",
    fullname: "No-Slip Plastic Seat Covers (500/roll)",
    colors: ["Plastic"],
    type: "service",
    default_color: "Plastic",
    discount: [{ quantity: 500, price: 73.5 }],
    sizes: {
      1: 73.5,
    },
  },
  {
    code: "3088",
    name: "Floor Mats",
    fullname: "Floor Mats/Coated Paper (500/bx)",
    colors: ["White"],
    type: "service",
    default_color: "White",
    discount: [{ quantity: 500, price: 76.44 }],
    sizes: {
      1: 76.44,
    },
  },
  {
    code: "BGVinyl",
    name: "Vinyl Sheet",
    fullname: "8.5 x 11 Blank Vinyl Sheet #9300 (100/pk)",
    colors: ["White"],
    type: "sales",
    default_color: "White",
    discount: [{ quantity: 1, price: 135.00 }],
    sizes: {
      default: 135.00,
    },
  },
  {
    code: "BGE12-AL",
    name: "Buyers Guide",
    fullname: "Buyers Guide, Blank Front (100/pk)",
    colors: ["White"],
    type: "sales",
    default_color: "White",
    discount: [{ quantity: 1, price: 74.95 }],
    sizes: {
      default: 74.95,
    },
  },
  {
    code: "3198WB",
    name: "Oval Year Stickers - Blue",
    fullname: "Oval Year Stickers - Blue/White (12/pk)",
    colors: [
      "YR 07",
      "YR 08",
      "YR 09",
      "YR 10",
      "YR 11",
      "YR 12",
      "YR 13",
      "YR 13",
      "YR 14",
      "YR 15",
      "YR 16",
      "YR 17",
      "YR 18",
      "YR 19",
      "YR 20",
      "YR 21",
      "YR 22",
      "YR 23",
      "YR 24",
      "YR 25",
      "YR 26",
    ],
    type: "sales",
    default_color: "YR 07",
    discount: [{ quantity: 1, price: 10.99 }],
    sizes: {
      1: 10.99,
    },
  },
  {
    code: "3198SB",
    name: "Oval Year Stickers - Silver",
    fullname: "Oval Year Stickers - Silver/Black (12/pk)",
    colors: [
      "YR 2016",
      "YR 2017",
      "YR 2018",
      "YR 2019",
      "YR 2020",
      "YR 2021",
      "YR 2022",
      "YR 2023",
      "YR 2024",
      "YR 2025",
      "YR 2026",      
    ],
    type: "sales",
    default_color: "YR 2016",
    discount: [{ quantity: 1, price: 10.99 }],
    sizes: {
      1: 10.99,
    },
  },
  {
    code: "GP955",
    name: "Grease Markers",
    fullname: "Grease Marker (1 each)",
    colors: [
      "Blue",
      "Green",
      "Pink",
      "Orange",
      "Purple",
      "Red",
      "White",
      "Yellow",
    ],
    type: "sales",
    default_color: "Blue",
    discount: [{ quantity: 1, price: 10.69 }],
    sizes: {
      1: 10.69,
    },
  },
  {
    code: "GP200",
    name: "Key Tags",
    fullname: "Versa-Tags Key Tag #200 (250/bx)",
    colors: [
      "Blue",
      "Gray",
      "Green",
      "Lilac",
      "Lime Green",
      "Orange",
      "Red",
      "Tan",
      "White",
      "Yellow",
    ],
    type: "sales",
    default_color: "Blue",
    discount: [{ quantity: 1, price: 36.95 }],
    sizes: {
      1: 36.95,
    },
  },
  {
    code: "GP546",
    name: "Deal Jackets",
    fullname: "Deal Jackets (500/box)",
    colors: [
      "Blue",
      "Buff",
      "Fuchsia",
      "Green",
      "Grey",
      "Lavender",
      "Pink",
      "Salmon",
      "White",
      "Yellow",
    ],
    type: "sales",
    default_color: "Blue",
    sizes: {
      1: 115.79,
    },
  },
  {
    code: "GP790",
    name: "Not for Sale Sticker",
    fullname: "Sticker - Vehicle Not for Sale (100/pk)",
    colors: ["Yellow"],
    type: "sales",
    default_color: "Yellow",
    discount: [{ quantity: 1, price: 27.95 }],
    sizes: {
      1: 27.95,
    },
  },
  {
    code: "VT400",
    name: "Stock Stickers",
    fullname: "Kleer-Back Stock Stickers Versa #400 (100/pk)",
    colors: ["Blue", "Green", "Orange", "Red", "White", "Yellow"],
    type: "sales",
    default_color: "Blue",
    sizes: {
      1: 17.95,
    },
  },
  {
    code: "CP91L",
    name: "Port & Company Beanie",
    fullname: "Port & Company® Fleece-Lined Beanie Cap",
    colors: ["Athletic Red", "Athletic Royal", "Black","Navy"],
    type: "mens",
    default_color: "Black",
    sizes: {
      OSFA: 12.99,
    },
  },
  {
    code: "112",
    name: "Richardson Trucker Cap",
    fullname: "Richardson Snapback Trucker Cap (addt'l logos cost extra)",
    colors: ["Amber Gold","Black","Charcoal","Loden","Maroon","Navy","White"],
    type: "mens",
    default_color: "Black",
    sizes: {
      OSFA: 21.99,
    },
  },
  {
    code: "NE205",
    name: "New Era® Trucker Cap",
    fullname: "New Era® Snapback Trucker Cap (addt'l logos cost extra)",
    colors: ["Black","Graphite","Grey","Deep Navywt"],
    type: "mens",
    default_color: "Black",
    sizes: {
      OSFA: 26.99,
    },
  },
  {
    code: "STC39",
    name: "Sport-Tek® Trucker Cap",
    fullname: "Sport-Tek® YP Classics® Retro Trucker Cap (addt'l logos cost extra)",
    colors: ["Black","Graphite","True Navy True Navy","True Navy White","White"],
    type: "mens",
    default_color: "Black",
    sizes: {
      OSFA: 21.99,
    },
  },
  {
    code: "BB18000",
    name: "Brooks Brothers® Shirt",
    fullname: "Brooks Brothers® Wrinkle-Free Stretch Pinpoint Shirt",
    colors: ["Cobalt Blue", "Deep Black","Newport Blue","White"],
    type: "mens",
    default_color: "Cobalt Blue",
    sizes: {
      Small: 79.99,
      Medium: 79.99,
      Large: 79.99,
      XLarge: 79.99,
      "2XLarge": 80.99,
      "3XLarge": 81.99,
      "4XLarge": 82.99,
    },
  },
  {
    code: "BB18002",
    name: "Brooks Brothers® Shirt",
    fullname: "Brooks Brothers® Wrinkle-Free Nailhead Shirt",
    colors: ["Cobalt Blue", "White"],
    type: "mens",
    default_color: "Cobalt Blue",
    sizes: {
      Small: 79.99,
      Medium: 79.99,
      Large: 79.99,
      XLarge: 79.99,
      "2XLarge": 80.99,
      "3XLarge": 81.99,
      "4XLarge": 82.99,
    },
  },
  {
    code: "BB18003",
    name: "Brooks Brothers® Shirt",
    fullname: "Brooks Brothers® Women's Wrinkle-Free Nailhead Shirt",
    colors: ["Cobalt Blue", "White"],
    type: "womens",
    default_color: "Cobalt Blue",
    sizes: {
      Small: 79.99,
      Medium: 79.99,
      Large: 79.99,
      XLarge: 79.99,
      "2XLarge": 80.99,
      "3XLarge": 81.99,
      "4XLarge": 82.99,
    },
  },
  {
    code: "S659",
    name: "Port Authority® Shirt",
    fullname: "Port Authority® Short Sleeve SuperPro™ Oxford Shirt",
    colors: ["Black", "Navy","Oxford Blue","White"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 35.99,
      Medium: 35.99,
      Large: 35.99,
      XLarge: 35.99,
      "2XLarge": 37.99,
      "3XLarge": 39.99,
      "4XLarge": 41.99,
    },
  },
  {
    code: "S608",
    name: "Port Authority® Shirt",
    fullname: "Port Authority® Long Sleeve Easy Care Shirt",
    colors: ["White"],
    type: "mens",
    default_color: "White",
    sizes: {
      Small: 34.99,
      Medium: 34.99,
      Large: 34.99,
      XLarge: 34.99,
      "2XLarge": 35.99,
      "3XLarge": 36.99,
      "4XLarge": 37.99,
      "5XLarge": 38.99,
      "6XLarge": 39.99,
    },
  },
  {
    code: "L608",
    name: "Port Authority® Shirt",
    fullname: "Port Authority® Women's Long Sleeve Shirt",
    colors: ["White"],
    type: "womens",
    default_color: "White",
    sizes: {
      Small: 34.99,
      Medium: 34.99,
      Large: 34.99,
      XLarge: 34.99,
      "2XLarge": 35.99,
      "3XLarge": 36.99,
      "4XLarge": 37.99,
      "5XLarge": 38.99,
      "6XLarge": 39.99,
    },
  },
  {
    code: "PC61",
    name: "Port & Company® Tee",
    fullname: "Port & Company® Essential Tee",
    colors: ["Athletic Heather","Cardinal","Charcoal","Jet Black",
      "Medium Grey","Navy","Red","Royal","White"],
    type: "mens",
    default_color: "Jet Black",
    sizes: {
      Small: 14.99,
      Medium: 14.99,
      Large: 14.99,
      XLarge: 14.99,
      "2XLarge": 16.99,
      "3XLarge": 18.99,
      "4XLarge": 20.99,
      "5XLarge": 22.99,
      "6XLarge": 24.99,
    },
  },
  {
    code: "267020",
    name: "Nike® Dri-FIT Classic Polo",
    fullname: "Nike® Dri-FIT Classic Polo",
    colors: ["Black","Court Blue","Light Blue","White"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 49.99,
      Medium: 49.99,
      Large: 49.99,
      XLarge: 49.99,
      "2XLarge": 50.99,
      "3XLarge": 52.99,
      "4XLarge": 54.99,     
    },
  },  
  {
    code: "286772",
    name: "Nike® Dri-FIT Classic Polo",
    fullname: "Nike® Women's Dri-FIT Classic Polo",
    colors: ["Black","Light Blue","White"],
    type: "womens",
    default_color: "Black",
    sizes: {
      Small: 49.99,
      Medium: 49.99,
      Large: 49.99,
      XLarge: 49.99,
      "2XLarge": 50.99,          
    },
  },  
  {
    code: "NKDC1963",
    name: "Nike® Dri-FIT Polo Shirt",
    fullname: "Nike® Dri-FIT Polo (addt'l logos cost extra)",
    colors: ["Anthracite", "Black", "Cool Grey", "Navy", "University Red","White"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 39.99,
      Medium: 39.99,
      Large: 39.99,
      XLarge: 39.99,
      "2XLarge": 41.99,
      "3XLarge": 43.99,
      "4XLarge": 45.99,     
    },
  },  
  {
    code: "883681",
    name: "Nike® Dri-FIT Legacy Polo",
    fullname: "Nike® Dri-FIT Legacy Polo (addt'l logos cost extra)",
    colors: ["Black","Dark Grey","Game Royal","Gym Red","Light Photo Blue","Midnight Navy"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 62.99,
      Medium: 62.99,
      Large: 62.99,
      XLarge: 62.99,
      "2XLarge": 64.99,
      "3XLarge": 66.99,
      "4XLarge": 68.99,     
    },
  }, 
  {
    code: "NKDC1991",
    name: "Ladies Nike® Polo",
    fullname: "Ladies Nike® Micro Pique Polo (addt'l logos cost extra)",
    colors: ["Anthracite", "Black", "Cool Grey", "Navy","White"],
    type: "womens",
    default_color: "Black",
    sizes: {
       Small: 39.99,
      Medium: 39.99,
      Large: 39.99,
      XLarge: 39.99,
      "2XLarge": 41.99,     
    },
  },  
  {
    code: "NKAH6266",
    name: "Nike Textured Polo",
    fullname: "Nike Dri-FIT Hex Textured Polo",
    colors: ["Black","Court Blue","Dark Grey","Game Royal","Gym Red","White"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 67.00,
      Medium: 67.00,
      Large: 67.00,
      XLarge: 67.00,
      "2XLarge": 69.00, 
      "3XLarge": 71.00,
      "4XLarge": 73.00,  
    },
  },  
  {
    code: "NKBV6042",
    name: "Nike® Essential Polo",
    fullname: "Nike® Dry Essential Solid Polo",
    colors: ["Black", "Game Royal", "Midnight Navy","University Blue", "University Red", "White"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 56.00,
      Medium: 56.00,
      Large: 56.00,
      XLarge: 56.00,
      "2XLarge": 58.00,
      "3XLarge": 60.00,
      "4XLarge": 62.00,     
    },
  },
  {
    code: "TM1MY399",
    name: "TravisMathew Polo",
    fullname: "TravisMathew Bayfront Solid Polo",
    colors: ["Black","Dark Grey","Insignia Blue","Roan Rouge"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 96.49,
      Medium: 96.49,
      Large: 96.49,
      XLarge: 96.49,
      "2XLarge": 98.49,
      "3XLarge": 100.49,          
    },
  },
  {
    code: "TM1MU410",
    name: "TravisMathew Performance Polo",
    fullname: "TravisMathew Coto Performance Polo",
    colors: ["Beryl Grn Hthr","Black","Blue Nights","Brilliant Blue Hthr","Federal Blue",
    "Quiet Shade Grey Hthr","Quiet Shade Gry Blk","Vintage Indigo Blk","White"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 79.99,
      Medium: 79.99,
      Large: 79.99,
      XLarge: 79.99,
      "2XLarge": 81.99,
      "3XLarge": 83.99,          
    },
  },
  {
    code: "OG101",
    name: "OGIO® - Caliber2.0 Polo",
    fullname: "OGIO® - Caliber2.0 Polo",
    colors: ["Blacktop"],
    type: "mens",
    default_color: "Blacktop",
    sizes: {
      Small: 32.99,
      Medium: 32.99,
      Large: 32.99,
      XLarge: 32.99,
      "2XLarge": 33.99,
      "3XLarge": 34.99,
      "4XLarge": 35.99,
    },
  },
  {
    code: "LOG101",
    name: "OGIO® - Jewel Polo",
    fullname: "OGIO® - Jewel Polo",
    colors: ["Blacktop"],
    type: "womens",
    default_color: "Blacktop",
    sizes: {
      Small: 32.99,
      Medium: 32.99,
      Large: 32.99,
      XLarge: 32.99,
      "2XLarge": 33.99,
      "3XLarge": 34.99,
      "4XLarge": 35.99,
    },
  },
  {
    code: "TM1WW003",
    name: "TravisMathew 1/4-Zip",
    fullname: "TravisMathew Women's Crestview 1/4-Zip",
    colors: ["Black"],
    type: "womens",
    default_color: "Black",
    sizes: {
      Small: 80.73,
      Medium: 80.73,
      Large: 80.73,
      XLarge: 80.73,
      "2XLarge": 82.73,      
    },
  },
  {
    code: "K110",
    name: "Port Authority UV Polo",
    fullname: "Port Authority® Dry Zone® UV Micro-Mesh Polo",
    colors: ["Carolina Blue","Coastal Blue","Deep Black","Graphite",
    "Gusty Grey","Rich Red","River Blue Navy","True Royal","White"],
    type: "mens",
    default_color: "Deep Black",
    sizes: {
      Small: 24.99,
      Medium: 24.99,
      Large: 24.99,
      XLarge: 24.99,
      "2XLarge": 26.99,
      "3XLarge": 28.99,
      "4XLarge": 30.99,
      "5XLarge": 32.99,
      "6XLarge": 34.99,
    },
  },
  {
    code: "ST350",
    name: "Sport-Tek PosiCharge Tee",
    fullname: "Sport-Tek PosiCharge Competitor Tee",
    colors: ["Black"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 10.99,
      Medium: 10.99,
      Large: 10.99,
      XLarge: 10.99,
      "2XLarge": 11.99,
      "3XLarge": 12.99,
      "4XLarge": 13.99,
    },
  },
  {
    code: "ST740",
    name: "Sport-Tek Polo",
    fullname: "Sport-Tek® UV Micropique Polo",
    colors: ["Black","Deep Red","Graphite","Grey Concrete",
      "True Navy","True Royal","White"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 29.99,
      Medium: 29.99,
      Large: 29.99,
      XLarge: 29.99,
      "2XLarge": 31.99,
      "3XLarge": 33.99,
      "4XLarge": 35.99,
    },
  },
  {
    code: "PC61LS",
    name: "Long Sleeve Tee",
    fullname: "Port & Company® Long Sleeve Essential Tee",
    colors: ["Ash", "Athletic Heather", "Cardinal", "Charcoal", 
      "Deep Navy","Jet Black","Navy","Red","Royal","White"],
    type: "mens",
    default_color: "Jet Black",
    sizes: {
      Small: 23.99,
      Medium: 23.99,
      Large: 23.99,
      XLarge: 23.99,
      "2XLarge": 25.99,
      "3XLarge": 27.99,
      "4XLarge": 29.99,
    },
  },
  {
    code: "PC90H",
    name: "Hooded Sweatshirt",
    fullname: "Port & Company® Essential Fleece Pullover Hooded Sweatshirt",
    colors: ["Athletic Heather","Cardinal","Charcoal",
      "Drk Hthr Gry","Jet Black","Navy","Red","Royal","White"],
    type: "mens",
    default_color: "Jet Black",
    sizes: {
      Small: 31.98,
      Medium: 31.98,
      Large: 31.98,
      XLarge: 31.98,
      "2XLarge": 33.98,
      "3XLarge": 35.98,
      "4XLarge": 37.98,
    },
  },
  {
    code: "F700",
    name: "Raglan Fleece",
    fullname: "Port Authority® C-FREE® Raglan Fleece",
    colors: ["Deep Black", "Grey Steel", "True Navy"],
    type: "mens",
    default_color: "Deep Black",
    sizes: {
      Small: 41.98,
      Medium: 41.98,
      Large: 41.98,
      XLarge: 41.98,
      "2XLarge": 43.98,
      "3XLarge": 45.98,
      "4XLarge": 47.98,
    },
  },
  {
    code: "TM1MZ339",
    name: "TravisMathew 1/4-Zip",
    fullname: "TravisMathew Coveside 1/4-Zip",
    colors: ["Black", "Blue Nights", "Drk Gry Hthr", "Light Blue Hthr"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 104.00,
      Medium: 104.00,
      Large: 104.00,
      XLarge: 104.00,
      "2XLarge": 106.00,
      "3XLarge": 108.00,           
    },
  },
  {
    code: "L317",
    name: "Port Authority® Jacket",
    fullname: "Port Authority® Women's Core Soft Shell Jacket",
    colors: ["Black"],
    type: "womens",
    default_color: "Black",
    sizes: {
      Small: 49.99,
      Medium: 49.99,
      Large: 49.99,
      XLarge: 49.99,
      "2XLarge": 50.99,
      "3XLarge": 51.99,
      "4XLarge": 52.99,
    },
  },
  {
    code: "J317",
    name: "Port Authority® Jacket",
    fullname: "Port Authority® Core Soft Shell Jacket",
    colors: ["Black"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 49.99,
      Medium: 49.99,
      Large: 49.99,
      XLarge: 49.99,
      "2XLarge": 50.99,
      "3XLarge": 51.99,
      "4XLarge": 52.99,
      "5XLarge": 53.99,
      "6XLarge": 54.99,
    },
  },
  {
    code: "J333",
    name: "Torrent Waterproof Jacket",
    fullname: "Port Authority® Torrent Waterproof Jacket",
    colors: ["Black", "Engine Red","Magnet","True Navy","True Royal"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 64.99,
      Medium: 64.99,
      Large: 64.99,
      XLarge: 64.99,
      "2XLarge": 66.99,
      "3XLarge": 68.99,
      "4XLarge": 70.99,     
    },
  },
  {
    code: "NKDR1543",
    name: "Nike® Hooded Jacket",
    fullname: "Nike® Hooded Soft Shell Jacket",
    colors: ["Black"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 124.00,
      Medium: 124.00,
      Large: 124.00,
      XLarge: 124.00,
      "2XLarge": 126.00,
      "3XLarge": 128.00,
      "4XLarge": 130.00,     
    },
  },
  {
    code: "J335",
    name: "Port Authority® Jacket",
    fullname: "Port Authority® Hooded Core Soft Shell Jacket",
    colors: ["Black"],
    type: "mens",
    default_color: "Black",
    sizes: {
      XSmall: 58.04,
      Small: 58.04,
      Medium: 58.04,
      Large: 58.04,
      XLarge: 58.04,
      "2XLarge": 60.04,
      "3XLarge": 62.04,
      "4XLarge": 64.04,     
    },
  },
  {
    code: "L335",
    name: "Port Authority® Jacket",
    fullname: "Port Authority® Women's Hooded Core Soft Shell Jacket",
    colors: ["Black"],
    type: "womens",
    default_color: "Black",
    sizes: {
      XSmall: 58.04,
      Small: 58.04,
      Medium: 58.04,
      Large: 58.04,
      XLarge: 58.04,
      "2XLarge": 60.04,
      "3XLarge": 62.04,
      "4XLarge": 64.04,     
    },
  },
  {
    code: "HENPRO-FOB-414917C",
    name: "Leather Key Fob (red stitch) - Porsche N ATL",
    fullname: "Metal & Black Leather Fob w/black, 186 red & 872 gold imprint",
    colors: ["Black"],
    type: "accessory",
    default_color: "Black",      
    discount: [
      { quantity: 500, price: 3.99 },     
    ],
    sizes: {
      500: 3.99,     
    },
  },
  {
    code: "HENPRO-FOB-415104C",
    name: "Leather Key Fob (white stitch) - Porsche N ATL",
    fullname: "Metal & Black Leather Fob w/black, 186 red & 872 gold imprint",
    colors: ["Black"],
    type: "accessory",
    default_color: "Black",    
    discount: [
      { quantity: 500, price: 3.99 },     
    ],
    sizes: {
      500: 3.99,     
    },
  },
  {
    code: "HENPMA-FOB-497832C",
    name: "Leather Key Fob (red stitch) - Porsche Marietta",
    fullname: "Metal & Black Leather Fob w/black, 186 red & 872 gold imprint",
    colors: ["Black"],
    type: "accessory",
    default_color: "Black",
        discount: [
      { quantity: 500, price: 3.99 },     
    ],
    sizes: {
      500: 3.99,     
    },
  },
  {
    code: "HENPMA-FOB-498046C",
    name: "Leather Key Fob (white stitch) - Porsche Marietta",
    fullname: "Metal & Black Leather Fob w/black, 186 red & 872 gold imprint",
    colors: ["Black"],
    type: "accessory",
    default_color: "Black",    
    discount: [
      { quantity: 500, price: 3.99 },     
    ],
    sizes: {
      500: 3.99,     
    },
  },
  {
    code: "HENLAT-GPLLKR-456506L",
    name: "Leather Key Fob - Lexus ATL",
    fullname: "Black Laser Engraved Leather Fob w/debossed leather imprint",
    colors: ["Black"],
    type: "accessory",
    default_color: "Black",    
    discount: [
      { quantity: 500, price: 3.19 },     
    ],
    sizes: {
      500: 3.19,     
    },
  },
  { code: "HENLAT-FOB-501621A",
    name: "Leather Key Fob - Lexus ATL",
    fullname: "Metal & Black Leather Fob w/black color fill",
    colors: ["Black"],
    type: "accessory",
    default_color: "Black",      
    discount: [
      { quantity: 500, price: 3.99 },     
    ],
    sizes: {
      500: 3.99,     
    },
  },
   { code: "HENLAL-FOB-509389L",
    name: "Leather Key Fob - Land Rover - N ATL",
    fullname: "Black Leather Fob with Laser engraved imprint",
    colors: ["Black"],
    type: "accessory",
    default_color: "Black",      
    discount: [
      { quantity: 500, price: 3.99 },     
    ],
    sizes: {
      500: 3.99,     
    },
  },
  {
    code: "HENLDU-GPLLKR-473091L",
    name: "Leather Key Fob - Lexus Gwinnett",
    fullname: "Black Laser Engraved Leather Fob w/debossed leather imprint",
    colors: ["Black"],
    type: "accessory",
    default_color: "Black",    
    discount: [
      { quantity: 1000, price: 3.19 },     
    ],
    sizes: {
      1000: 3.19,     
    },
  },
  {
    code: "HENLDU-G1640-427215L",
    name: "Leather Key Fob - Lexus Gwinnett",
    fullname: "Black Laser Engraved Leather Fob",
    colors: ["Black"],
    type: "accessory",
    default_color: "Black",    
    discount: [
      { quantity: 1000, price: 3.19 },     
    ],
    sizes: {
      1000: 3.19,     
    },
  },
  {
    code: "HENADU-GPLLKR-497621L",
    name: "Leather Key Fob (green stitch) - Land Rover Gwinnett",
    fullname: "Black Laser Engraved Leather Fob",
    colors: ["Black"],
    type: "accessory",
    default_color: "Black",    
    discount: [
      { quantity: 250, price: 3.49 },     
    ],
    sizes: {
      250: 3.49,     
    },
  },
  {
    code: "HENCDU-G1640-475097LL",
    name: "Leather Key Fob - Cadillac Duluth",
    fullname: "Black Laser Engraved Leather Fob",
    colors: ["Black"],
    type: "accessory",
    default_color: "Black",    
    discount: [
      { quantity: 300, price: 3.29 },     
    ],
    sizes: {
      300: 3.29,     
    },
  },
  {
    code: "CG1640",
    name: "Laser Engraved Keychain",
    fullname: "Brushed Zinc/Leather Key Tag w/Laser Engraved Imprint",
    colors: ["Black"],
    type: "accessory",
    default_color: "Black",
    discount: [
      { quantity: 500, price: 3.99 },
      { quantity: 1000, price: 3.29 },
      { quantity: 2500, price: 2.99 },
    ],
    sizes: {
      500: 0.0,
      1000: 0.0,
      2500: 0.0,
    },
  },
  {
    code: "HENFAT-FOB-506092",
    name: "Laser Engraved Keychain",
    fullname: "Chrome Keychain w/laser engraved imprint",
    colors: ["Metal"],
    type: "accessory",
    default_color: "Metal",
    sizes: {
      500: 3.59,
    },
  },
  {
    code: "HENFAT-FOB-505249",
    name: "Laser Engraved Keychain",
    fullname: "Blue Banner Keychain w/Laser Engraved Imprint",
    colors: ["Metal"],
    type: "accessory",
    default_color: "Metal",
    discount: [
      { quantity: 500, price: 2.39 },
      { quantity: 1000, price: 2.19 },
      { quantity: 2500, price: 1.99 },
    ],
    sizes: {
      500: 0.0,
      1000: 0.0,
      2500: 0.0,
    },
  },
  {
    code: "HENMMO-FOB-502771L",
    name: "Matte Black Keychain - Southlake Mazda Buick GMC",
    fullname: "Matte Black Keychain w/frost effect engraving (#CG-1070)",
    colors: ["Black"],
    type: "accessory",
    default_color: "Black",
    discount: [
      { quantity: 500, price: 3.99 },      
    ],
    sizes: {
      500: 0.0,      
    },
  },
  {
    code: "HENLAT-34MLF-379167A",
    name: "Zinc Metal Frame",
    fullname: "Zinc Metal Frame w/glossy black imprint",
    colors: ["Metal"],
    type: "customs",
    default_color: "Metal",
    supportedStores: ["HENLAT"],
    sizes: {
      1000: 0.99,      
    },
  },
  {
    code: "HENLAT-G24-367503A",
    name: "Poly Coated Plate",
    fullname: "Poly Coated Plate w/black imprint",
    colors: ["Black"],
    type: "customs",
    default_color: "Black",
    supportedStores: ["HENLAT"],
    sizes: {
      2500: 0.79,      
    },
  },
  {
    code: "HENLAL-G24-373653SA",
    name: "Poly Coated Plate",
    fullname: "Poly Coated Plate w/black imprint",
    colors: ["Black"],
    type: "customs",
    default_color: "Black",
    supportedStores: ["HENLAL"],
    sizes: {
      1000: 0.79,      
    },
  },
   {
    code: "HENLAT-33GT-497684Z",
    name: "Plastic Plate",
    fullname: "Plastic plate w/full color imprint",
    colors: ["Black"],
    type: "customs",
    default_color: "Black",
    supportedStores: ["HENLAT"],
    sizes: {
      250: 1.89,      
    },
  },
   {
    code: "HENLAT-33P-391710A",
    name: "Plastic Plate",
    fullname: "Plastic plate w/black imprint",
    colors: ["Black"],
    type: "customs",
    default_color: "Black",
    supportedStores: ["HENLAT"],
    sizes: {
      1000: 0.99,      
    },
  },
  {
    code: "HENPRO-33P-458858A",
    name: "Test Drive Plate",
    fullname: "TEST DRIVE - Plastic Plate w/black imprint",
    colors: ["Black"],
    type: "customs",
    default_color: "Black",
    supportedStores: ["HENPRO"],
    sizes: {
      1000: 0.99,      
    },
  },
  {
    code: "HENPMA-33P-497831A",
    name: "Test Drive Plate",
    fullname: "TEST DRIVE - Plastic Plate w/black imprint",
    colors: ["Black"],
    type: "customs",
    default_color: "Black",
    supportedStores: ["HENPMA"],
    sizes: {
      1000: 0.99,      
    },
  },
  {
    code: "HENPRO-34MLF-426579A",
    name: "Black Metal Frame",
    fullname: "Black Metal Frame w/white imprint",
    colors: ["Black"],
    type: "customs",
    default_color: "Black",
    supportedStores: ["HENPRO"],
    sizes: {
      1000: 0.0279,      
    },
  },
  {
    code: "HENPMA-34MLF-497830A",
    name: "Black Metal Frame",
    fullname: "Black Metal Frame w/white imprint",
    colors: ["Black"],
    type: "customs",
    default_color: "Black",
    supportedStores: ["HENPMA"],
    sizes: {
      1000: 0.0279,      
    },
  },
  {
    code: "HENFAT31DD",
    name: "Die Cut Decal",
    fullname: "Decal Thermo Die Cut Decal",
    colors: ["Black", "Silver", "White"],
    type: "customs",
    default_color: "Black",
    supportedStores: ["HENFAT"],
    sizes: {
      1000: 0.75,
      2500: 0.65,
    },
  },
  {
    code: "HENMMO-31DD-504444A",
    name: "Die Cut Decal",
    fullname: "Black Vinyl Die Cut Decal",
    colors: ["Black"],
    type: "customs",
    default_color: "Black",
    supportedStores: ["HENMMO"],
    sizes: {
      500: 0.89,      
    },
  },
  {
    code: "HENFAT-34MRE-419207",
    name: "Aluminum Embossed Plate",
    fullname: "Aluminum Plate w/black imprint",
    colors: ["Black"],
    type: "customs",
    default_color: "Black",
    supportedStores: ["HENFAT"],
    sizes: {
      500: 3.59,
      1000: 3.19,
    },
  },
  {
    code: "HENFAT-34MRE-418853",
    name: "Aluminum Embossed Plate",
    fullname: "White Aluminum Plate w/blue imprint",
    colors: ["White"],
    type: "customs",
    default_color: "White",
    supportedStores: ["HENFAT"],
    sizes: {
      1000: 3.59,
      2500: 3.19,
    },
  },
  {
    code: "HENFAT-34MLF-445719",
    name: "Zinc Metal Frame",
    fullname: "Standard Zinc Metal Frame",
    colors: ["Metal"],
    type: "customs",
    default_color: "Metal",
    supportedStores: ["HENFAT"],
    sizes: {
      1000: 3.69,
      2500: 3.09,
    },
  },
  {
    code: "HENLDU-33P3DS-379346A",
    name: "3D Plastic Plate",
    fullname: "Black 3D Plastic Plate w/matte silver imprint",
    colors: ["Black"],
    type: "customs",
    default_color: "Black",
    supportedStores: ["HENLDU"],
    sizes: {
      200: 2.39,      
    },
  },
  {
    code: "HENLDU-34MLF-366502A",
    name: "Zinc Metal Frame",
    fullname: "Zinc Metal Frame w/black imprint",
    colors: ["Metal"],
    type: "customs",
    default_color: "Metal",
    supportedStores: ["HENLDU"],
    sizes: {      
      2500: 3.35,
    },
  },
  {
    code: "HENCDU-34MLF-485630A",
    name: "Black Metal Frame",
    fullname: "Black Metal Frame w/white imprint",
    colors: ["Black"],
    type: "customs",
    default_color: "Black",
    supportedStores: ["HENCDU"],
    sizes: {      
      250: 3.59,
    },
  },
  {
    code: "HENLDU-33P-497607A",
    name: "Certified Tag",
    fullname: "Lexus Certified Tag",
    colors: ["Black"],
    type: "customs",
    default_color: "Black",
    supportedStores: ["HENLDU"],
    sizes: {
      1000: .79,      
    },
  },
  {
    code: "HENADU-33P-492576A",
    name: "Land Rover Tag",
    fullname: "Land Rover Black Tag",
    colors: ["Black"],
    type: "customs",
    default_color: "Black",
    supportedStores: ["HENADU"],
    sizes: {
      500: 1.29,      
    },
  },
  {
    code: "HENLDU-33G24-373661B",
    name: "Poly Coated Plate",
    fullname: "White Poly Coated Plate w/black & 36 metallic imprint",
    colors: ["White"],
    type: "customs",
    default_color: "White",
    supportedStores: ["HENLDU"],
    sizes: {     
      2500: .89,
    },
  },
  {
    code: "HENCDU-G24-365677B",
    name: "Drive Out Tag",
    fullname: "White Poly Coated Plate w/black & 36 metallic gold imprint",
    colors: ["White"],
    type: "customs",
    default_color: "White",
    supportedStores: ["HENCDU"],
    sizes: {     
      500: 1.39,
    },
  },
  {
    code: "HENFAT-280C-497703",
    name: "Hang Tag",
    fullname: "VIP OFFER Hang Tag",
    colors: ["White"],
    type: "service",
    default_color: "White",
    sizes: {
      500: 0.89,
      1000: 0.69,
    },
  },
  {
    code: "HENFAT-280C-491902",
    name: "Hang Tag",
    fullname: "SOLD Hang Tag",
    colors: ["White"],
    type: "service",
    default_color: "White",
    sizes: {
      1000: 0.89,
      2500: 0.69,
    },
  },
  {
    code: "HENFAT-33G24-443352",
    name: "Poly Coated Plate",
    fullname: "Poly Coated Cardboard w/black/blue imprint",
    colors: ["Black"],
    type: "customs",
    default_color: "Black",
    supportedStores: ["HENFAT"],
    sizes: {
      1000: 0.89,
      2500: 0.79,
      5000: 0.69,
    },
  },
  {
    code: "HENADU-G24-385877A",
    name: "Poly Coated Plate",
    fullname: "Poly Coated Cardboard w/dark green imprint",
    colors: ["Dk Green"],
    type: "customs",
    default_color: "Dk Green",
    supportedStores: ["HENADU"],
    sizes: {
      500: 0.99,      
    },
  },
  {
    code: "HENHWO-31DD-343372",
    name: "Die Cut Decal",
    fullname: "Black & 285 Blue Die Cut Decal (screened on clear)",
    colors: ["Black"],
    type: "customs",
    default_color: "Black",
    supportedStores: ["HENHWO"],
    sizes: {     
      2500: 0.89,      
    },
  },
  {
    code: "HENHWO-33P-376460B",
    name: "Drive Out Tag",
    fullname: "Poly Coated Cardboard w/black & 293 blue imprint",
    colors: ["White"],
    type: "customs",
    default_color: "White",
    supportedStores: ["HENHWO"],
    sizes: {
      2500: 0.95,
      
    },
  },
  {
    code: "HENCDU-33P-370807A",
    name: "Hennessy Cadillac Tag",
    fullname: "Poly Coated Cardboard w/cool gray 11 imprint",
    colors: ["White"],
    type: "customs",
    default_color: "White",
    supportedStores: ["HENCDU"],
    sizes: {
      300: 1.39,
      
    },
  },
  {
    code: "HENHWO-34CP-377796A",
    name: "Chrome Plated Frame",
    fullname: "Chrome Plated Frame w/black imprint",
    colors: ["Chrome Plated"],
    type: "customs",
    default_color: "Chrome Plated",
    supportedStores: ["HENHWO"],
    sizes: {
      2500: 3.35,
      
    },
  },
  {
    code: "HENADU-34CF-437447A",
    name: "Chrome Faced Frame",
    fullname: "Chrome Faced Frame w/black imprint",
    colors: ["Chrome"],
    type: "customs",
    default_color: "Chrome",
    supportedStores: ["HENADU"],
    sizes: {
      500: 1.49,
      
    },
  },
  {
    code: "HENMMO-34CF-503744A",
    name: "Chrome Faced Frame",
    fullname: "Chrome Faced Frame w/black imprint",
    colors: ["Chrome"],
    type: "customs",
    default_color: "Chrome",
    supportedStores: ["HENMMO"],
    sizes: {
      500: 1.39,
      
    },
  },
  {
    code: "HENMMO-34CF-503933A",
    name: "Chrome Faced Frame",
    fullname: "Chrome Faced Frame w/black imprint",
    colors: ["Chrome"],
    type: "customs",
    default_color: "Chrome",
    supportedStores: ["HENMMO"],
    sizes: {
      500: 1.39,
      
    },
  },
  {
    code: "HENLAL-34CF-459349A",
    name: "Chrome Faced Frame",
    fullname: "Chrome Faced Frame w/black imprint",
    colors: ["Chrome Faced"],
    type: "customs",
    default_color: "Chrome Faced",
    supportedStores: ["HENLAL"],
    sizes: {
      1000: 1.39,
      
    },
  },
  {
    code: "HENCDU-34CF-370808A",
    name: "Chrome Faced Frame",
    fullname: "Chrome Faced Frame w/black imprint",
    colors: ["Chrome"],
    type: "customs",
    default_color: "Chrome",
    supportedStores: ["HENCDU"],
    sizes: {
      300: 1.39,
      
    },
  },
  {
    code: "HENMMO-THC-477566A",
    name: "Domecal Hitch Cover",
    fullname: "Domecal Hitch Cover",
    colors: ["Black"],
    type: "customs",
    default_color: "Black",
    supportedStores: ["HENMMO"],
    sizes: {
      250: 4.49,
      
    },
  },
  {
    code: "HENHWO-33P3D-376461A",
    name: "3D Tag",
    fullname: "3D Black Plate w/white imprint",
    colors: ["Black"],
    type: "customs",
    default_color: "Black",
    supportedStores: ["HENHWO"],
    sizes: {      
      2500: 2.39,
      
    },
  },
  {
    code: "HENFAT-1830-478437",
    name: "Service Due Sticker",
    fullname: "Service Due Sticker w/QR code",
    colors: ["White"],
    type: "service",
    default_color: "White",
    sizes: {
      5000: 0.21,
      10000: 0.19,
    },
  },
  {
    code: "HENCDU-STKR-506185Z",
    name: "Caution Sticker - Cadillac Duluth",
    fullname: "40 Mineral Orange Vinyl Sticker w/black imprint",
    colors: ["Orange"],
    type: "service",
    default_color: "Orange",
    sizes: {
      1500: 0.89,      
    },
  },
  {
    code: "HENCDU-CERT-481428Z",
    name: "SVC Certificate - Cadillac Duluth",
    fullname: "Free Service Certificate",
    colors: ["Black"],
    type: "service",
    default_color: "Black",
    sizes: {
      500: .39,      
    },
  },
  {
    code: "HENCDU-PEN-495480A",
    name: "Blue Maxiglide Pen - Cadillac Duluth",
    fullname: "Blue Maxiglide Pure Pen w/white imprint (#582)",
    colors: ["Blue"],
    type: "accessory",
    default_color: "Blue",
    sizes: {
      500: .79,
    },
  },
  {
    code: "HENFAT-MUG-505968",
    name: "15oz. Mug w/imprint",
    fullname: "Royal 15oz. Ember Mug w/silver imprint",
    colors: ["Royal"],
    type: "accessory",
    default_color: "Royal",
    sizes: {
      360: 2.89,
    },
  },
  {
    code: "HENFAT-MUG-492907",
    name: "15oz. Mug w/imprint",
    fullname: "Black 15oz. Mug w/laser engraved imprint",
    colors: ["Black"],
    type: "accessory",
    default_color: "Black",
    sizes: {
      1000: 1.69,
    },
  },
  {
    code: "HENCDU-KOOZIE-508516A",
    name: "Black Kan-Tastic - Cadillac Duluth",
    fullname: "Black Kan-Tastic w/white imprint (#34)",
    colors: ["Black"],
    type: "accessory",
    default_color: "Black",
    sizes: {
      250: .99,
    },
  },
  {
    code: "HENCDU-BOTTLE-508517A",
    name: "Black 24oz Bottle - Cadillac Duluth",
    fullname: "Black 24oz Stainless Steel Bottle w/white imprint (#50240)",
    colors: ["Black"],
    type: "accessory",
    default_color: "Black",
    sizes: {
      96: 17.99,
    },
  },
  {
    code: "HENFAT-TOTE-493101",
    name: "Vinyl Tote w/imprint",
    fullname: "Vinyl Tote w/full color imprint",
    colors: ["Black"],
    type: "accessory",
    default_color: "Black",
    sizes: {
      1000: 1.69,
    },
  },
  {
    code: "HENPMA-TOTE-2ML8410",
    name: "Matte Tote 8 x 10 x 4",
    fullname: "White Matte Laminated Euro Tote w/black imprint (8x10x4)",
    colors: ["White"],
    type: "accessory",
    default_color: "White",
    sizes: {
      250: 1.39,
    },
  },
  {
    code: "HENPMA-TOTE-2L13510",
    name: "Laminated Tote 13 x 10 x 5",
    fullname: "White Gloss Laminated Euro Tote w/black imprint (13x10x5)",
    colors: ["White"],
    type: "accessory",
    default_color: "White",
    sizes: {
      250: 1.55,
    },
  },
  {
    code: "HENPMA-TOTE-2L16612",
    name: "Laminated Tote 16 x 12 x 6",
    fullname: "White Gloss Laminated Euro Tote w/black imprint (16x12x6)",
    colors: ["White"],
    type: "accessory",
    default_color: "White",
    sizes: {
      250: 1.69,
    },
  },
  {
    code: "HENFAT-TOTE-492717",
    name: "Laminated Tote w/imprint",
    fullname: "Black Gloss Laminated Tote w/white imprint",
    colors: ["Black"],
    type: "accessory",
    default_color: "Black",
    sizes: {
      100: 2.29,
    },
  },
];
